export default __webpack_public_path__ + "static/checklist-872ec922a9f09fad1d30b47d1eff9d22.png";